
  export default {
    props: {
      article: { type: Object, required: true }
    },
    data () {
      return {
        C0004: false
      };
    },
    computed: {
      onetrustCompliant () {
        return this.article.video_id && this.C0004;
      },
      wrappedBody () {
        // Wraps any <table> elements in a div.table-wrapper
        // Makes it easier to style on mobile
        if (this.article.body === null) return null;
        const wrappedTable = '<div class="table-wrapper">$&</div>';
        const regex = /<table\b[^>]*>[\s\S]*?<\/table>/gi;
        return this.article.body.replace(regex, wrappedTable);
      }
    },
    mounted () {
      window.OptanonWrapper = () => {
        this.C0004 = window.OnetrustActiveGroups.includes('C0004');
      };
    }
  };
